import { combineReducers } from 'redux'
import auth from './authReducer'
import documentos from './documentosReducers'


export default combineReducers({
    auth,
    documentos
})